import React from 'react';
import { motion } from 'framer-motion';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface TeamProps {
  language: Language;
}
interface TeamMember {
  nameEn: string;
  namePs: string;
  image?: string;
}
interface TeamGroup {
  titleEn: string;
  titlePs: string;
  members: TeamMember[];
}
export function Team({
  language
}: TeamProps) {
  const isPashto = language === 'pashto';
  const groups: TeamGroup[] = [{
    titleEn: 'Patron',
    titlePs: 'نګران',
    members: [{
      nameEn: 'Dr. Israr',
      namePs: 'ډاکټر اسرار',
      image: 'https://cdn.magicpatterns.com/uploads/pptyLzVbkMq6xu3T3RSTum/Dr_Israr_نګران.jpg'
    }]
  }, {
    titleEn: 'Editor',
    titlePs: 'ترتیب کوونکی',
    members: [{
      nameEn: 'Hazrat Zubair Zubair',
      namePs: 'حضرت زبېر زبېر',
      image: 'https://cdn.magicpatterns.com/uploads/9pZXnQ8pfVZMpn4omeCV4V/Hazrat_Zubair_Zubair_ترتیب.jpg'
    }]
  }, {
    titleEn: 'Advisory Board',
    titlePs: 'مشاورتي بورډ',
    members: [{
      nameEn: 'Mushtaq ur Rahman Shafaq',
      namePs: 'مشتاق الرحمن شفق',
      image: 'https://cdn.magicpatterns.com/uploads/3VTxZZ1x6F4YPFK5K6oyNp/Mushtaq_ur_Rahman_Shafaq_مشاورتي_بورډ.jpg'
    }, {
      nameEn: 'Rahmat Shah Sayel',
      namePs: 'رحمت شاه سایل',
      image: 'https://cdn.magicpatterns.com/uploads/i2Ac6Zj5FCbCPfaCT1RWR4/Rahmat_Shah_Sayel_مشاورتي_بورډ.jpg'
    }, {
      nameEn: 'Gul Mohammad Betab',
      namePs: 'ګل محمد بېتاب',
      image: 'https://cdn.magicpatterns.com/uploads/sVrJTc5F3byF1KufRZcqm8/Gul_Mohammad_Betab_مشاورتي_بورډ.jpg'
    }]
  }, {
    titleEn: 'Legal Advisor',
    titlePs: 'قانوني مشیر',
    members: [{
      nameEn: 'Akbar Hoti',
      namePs: 'اکبر هوتي',
      image: 'https://cdn.magicpatterns.com/uploads/stQSRoqzWmxgtpJMA2wpyF/Akbar_Hoti.jpg_قانوني_مشیر_.jpg'
    }]
  }, {
    titleEn: 'Associate Editors',
    titlePs: 'ملګري مرستیالان',
    members: [{
      nameEn: 'Owais Qarni',
      namePs: 'اوېس قرني',
      image: 'https://cdn.magicpatterns.com/uploads/uhA2Ew9fYziPzCwftYLtTv/Owais_Qarni_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Syed Afzal Shah',
      namePs: 'سید افضل شاه',
      image: 'https://cdn.magicpatterns.com/uploads/kx3KmXdo55pmtbB2KCqWsG/Syed_Afzal_Shah_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Ijaz Afghani',
      namePs: 'اعجاز افغاني',
      image: 'https://cdn.magicpatterns.com/uploads/adV4Ds2Y7W8P8dRay2HVjg/Ijaz_Afghani_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Inam Shah Inam',
      namePs: 'انعام شاه انعام',
      image: 'https://cdn.magicpatterns.com/uploads/4CVcdRmhrsCtjNymt6s439/Inam_Shah_Inam_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Muhammad Usman Mardanvi',
      namePs: 'محمد عثمان مردانوی',
      image: 'https://cdn.magicpatterns.com/uploads/sjNnsQS8spXPB4KipK3BHw/Muhammad_Usman_Mardanvi_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Hameed Hatif',
      namePs: 'حميد هاتف',
      image: 'https://cdn.magicpatterns.com/uploads/5bh3ehLYreWWZFnJzrS9QE/Hameed_Hatif_ملګرې_مرستیال.jpg'
    }, {
      nameEn: 'Azhar Khattak',
      namePs: 'اظهر خټک',
      image: 'https://cdn.magicpatterns.com/uploads/2iRdrx5MDo1aLwSeUFFwvv/Azhar_Khattak_ملګرې_مرستیال.jpg'
    }]
  }, {
    titleEn: 'Print Manager',
    titlePs: 'د چاپ منتظم',
    members: [{
      nameEn: 'Syed Muhammad Ali',
      namePs: 'سید محمد علي',
      image: 'https://cdn.magicpatterns.com/uploads/cgg1UxsGexq94e5gtQhUYG/Syed_Muhammad_Ali_د_چاپ_منتظم.jpg'
    }]
  }, {
    titleEn: 'Student Liaison',
    titlePs: 'د طالبعلمانو سره رابطه کونکی',
    members: [{
      nameEn: 'Hazrat Gul',
      namePs: 'حضرت ګل',
      image: 'https://cdn.magicpatterns.com/uploads/whhrsFGJRqNZZRFUVLVbj7/Hazrat_Gul_طالعلمانو_سره_رابطه_کونکی.jpg'
    }]
  }];
  return <div className="pt-24 md:pt-28 bg-gray-50 min-h-screen pb-12" data-id="element-767">
      <PageHero language={language} titleEn="The Team" titlePs="زموږ ټیم" introEn="Meet the dedicated people behind Pasoon magazine." introPs="د پاڅون مجلې تر شا د وقف شویو خلکو سره وپیژنئ." data-id="element-768" />

      <div className="max-w-6xl mx-auto px-6" data-id="element-769">
        {groups.map((group, gIdx) => <section key={gIdx} className="py-8 md:py-10" data-id="element-770">
            {/* Group Heading */}
            <div className="mb-8 text-start" data-id="element-771">
              <h2 className={`text-2xl md:text-3xl font-bold text-pasoon-dark inline-block relative ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-772">
                {isPashto ? group.titlePs : group.titleEn}
                <span className="absolute -bottom-2 start-0 w-1/2 h-1 bg-pasoon-red rounded-full" data-id="element-773"></span>
              </h2>
            </div>

            {/* Members Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-774">
              {group.members.map((member, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx % 6 * 0.06,
            duration: 0.4
          }} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-775">
                  {/* Image */}
                  <div className="aspect-[3/4] bg-gradient-to-b from-pasoon-red/5 to-pasoon-red/10 flex items-center justify-center overflow-hidden" data-id="element-776">
                    {member.image ? <img src={member.image} alt={isPashto ? member.namePs : member.nameEn} className="w-full h-full object-contain" data-id="element-777" /> : <div className="w-24 h-24 rounded-full bg-pasoon-red/20 border-4 border-white flex items-center justify-center text-pasoon-red text-3xl font-bold" data-id="element-778">
                        {isPashto ? member.namePs.charAt(0) : member.nameEn.charAt(0)}
                      </div>}
                  </div>

                  {/* Details */}
                  <div className="p-5 text-center" data-id="element-779">
                    <h3 className={`text-lg font-bold text-pasoon-dark ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-780">
                      {isPashto ? member.namePs : member.nameEn}
                    </h3>
                  </div>
                </motion.div>)}
            </div>
          </section>)}
      </div>
    </div>;
}